import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import CustOperationView from '../views/CustOperationView.vue'
import InBill from '../views/InBill.vue'
import store from '../store'
import { byVariant } from './templateSwitch'

// Order Hist has two versions, picked in the user menu: the original page (lightly
// polished via .oh-classic) and the redesign.
const OrderHistView = byVariant('OrderHistView', 'orderHist', {
  old: () => import('../views/OrderHistView.vue'),
  new: () => import('../views/OrderHistV2View.vue'),
}, 'new', { old: 'oh-classic' })
const CSNoteView = () => import('../views/CSNoteView.vue')
const DataLoad = () => import('../views/DataLoad.vue')
const ControlPage = () => import('../views/ControlPage.vue')
const InShip = () => import('../views/InShip.vue')
const SettingsView = () => import('../views/SettingsView.vue')
const ShippingToolView = () => import('../views/ShippingToolView.vue')
const LoginView = () => import('../views/LoginView.vue')

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/csnote',
    name: 'CSNoteView',
    component: CSNoteView,
    meta: { requiresAuth: true }
  },
  {
    path: '/custoperation',
    name: 'CustOperationView',
    component: CustOperationView,
    meta: { requiresAuth: true ,
      requiresPlaning: true
    }
  }
  ,
  {
    path: '/orderhistory',
    name: 'OrderHistView',
    component: OrderHistView,
    meta: { requiresAuth: true }
  },
  {
    // the redesign now lives at /orderhistory; keep old links working
    path: '/orderhistory2',
    redirect: to => ({ path: '/orderhistory', query: to.query })
  },
  {
    path: '/dataload',
    name: 'DataLoad',
    component: DataLoad,
    meta: { 
      requiresAuth: true ,
      requiresPlaning: true
    
    }
  }
  ,
  {
    path: '/controlpage',
    name: 'ControlPage',
    component: ControlPage,
    meta: { 
      requiresAuth: true ,
      requiresPlaning: true
    
    }
  },
  {
    path: '/inbill',
    name: 'InBill',
    component: InBill,
    meta: { 
      requiresAuth: true ,
    }
  },
  {
    path: '/inship',
    name: 'InShip',
    component: InShip,
    meta: {
      requiresAuth: true ,
    }
  },
  {
    path: '/settings',
    name: 'SettingsView',
    component: SettingsView,
    meta: {
      requiresAuth: true,
      requiresPlaning: true
    }
  },
  {
    path: '/shippingtool',
    name: 'ShippingToolView',
    component: ShippingToolView,
    meta: {
      requiresAuth: true,
      requiresPlaning: true
    }
  }
]

const router = createRouter({
  currentURL: '',
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  // console.log('router.beforeEach')
  // console.log(store)
  
  if ((to.matched.some(record => record.meta.requiresAuth)) && !(store.getters.isAuthenticated) ) {
    next({name: 'login', query: { to: to.path }})
    
  } else {
    next()
    
  }

})

export default router
